var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRigth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5842 11.0001L13.7077 8.11555C13.319 7.72576 13.3195 7.0948 13.7087 6.70555C14.0984 6.31592 14.7301 6.31592 15.1197 6.70555L19.7071 11.293C20.0976 11.6835 20.0976 12.3166 19.7071 12.7072L15.1197 17.2946C14.7301 17.6842 14.0984 17.6842 13.7087 17.2946C13.3195 16.9053 13.319 16.2744 13.7077 15.8846L16.5842 13.0001H5.41421C4.86193 13.0001 4.41421 12.5523 4.41421 12.0001C4.41421 11.4478 4.86193 11.0001 5.41421 11.0001H16.5842Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRigth);
export default __webpack_public_path__ + "static/media/Rigth.90b054639b114ee43abe3d8519c76785.svg";
export { ForwardRef as ReactComponent };